import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
 import { closeOrderPopUp } from "../../action/hCommerce2";
 import { sendAnalytics } from "../../../action/homeAction";
import { CMSPath } from "../../../config/constant";
import { scrollToTop } from "../../../JS/scrollToTop";


const SpaBooking3a = (props) => {

    const { t } = props
    const [selectedServiceId, setSelectedServiceId] = useState(null);
    const [selectedServiceData, setSelectedServiceData] = useState({});


    const handleBack = () => {
        props.goBack();
    }

    const handleNext = () => {
        props.next(selectedServiceId)
    }

    useEffect(() => {

        let dataFound = false;
        props.serviceData.services.forEach(service => {
            if (service.id == selectedServiceId) {
                setSelectedServiceData(service);
                dataFound = true;
                return;
            }
        });

        if(!dataFound){
            setSelectedServiceData({});
        }

    }, [selectedServiceId])

    useEffect(() => {
        scrollToTop();
        setSelectedServiceId(props.selectedServiceId);
        console.log("propsservicedata",props.serviceData)
    }, [])

    return (
        <section class="widgets spa-listing spa-details">

            <div class="widget-header">
                {props.currentWidgetObj.widgetHeaderImageUrl &&
                    <div class="widget-header-img">
                        <img src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`} alt={props.currentWidgetObj.displayName} />
                    </div>
                }
                <div class="widget-header-title">{t(`spaBooking.heading3`)}</div>
                <div class="widget-header-subtitle">{t(`spaBooking.sub_heading3`)}</div>
            </div>

            <div class="widgets">
                <div class="row margin-bottom-2">
                    <div class="row">
                        <div class="col">
                            <div class="detail-body stay-body">
                                <form>

                                    <div class="form-row">
                                        <p class="heading">{t(`spaBooking.select_service`)}</p>
                                        <select onChange={(e) => {setSelectedServiceId(e.target.value)}} value={selectedServiceId} className="lang">
                                            <option key={0} value={""}>{t("spaBooking.select_preffered_service")}</option>
                                            {props.serviceData.services.map((service, index) => (
                                                <option key={index} value={service.id}>
                                                    {service.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {selectedServiceData.description || selectedServiceData.extendedDescription &&
                                        <div class="form-row">
                                            <p class="heading">{t(`spaBooking.service_description`)}</p>
                                            <p class="sub-text">{selectedServiceData.description || selectedServiceData.extendedDescription}</p>
                                            
                                        </div>
                                    }

                                    {Object.keys(selectedServiceData).length > 0 && 
                                    <div class="form-row price-total">
                                        <label>{t(`spaBooking.duration`)}<span>{selectedServiceData.duration}{` ${t("spaBooking.minutes")}`}</span></label>
                                        <label>{t(`spaBooking.base_price`)}<span>{`${props.currencyCode} ${selectedServiceData.price}`}<span class="spa-price-per-person 3a">{t("spaBooking.per_person")}</span></span></label>
                                        <div class="disclaimer">
                                            {selectedServiceData.warningNotes}
                                        </div>
                                    </div>
                                    }

                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-controls">
                            <button disabled={Object.keys(selectedServiceData).length == 0} onClick={handleNext}>{t('spaBooking.next')}</button>
                            <button onClick={handleBack}>{t('spaBooking.back')}</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )

}

const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        currencyCode: state.store.home.clientConfig.currencyDetails ?
            state.store.home.clientConfig.currencyDetails.code : "",
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
    }
}

export default connect(mapStateToProps, { closeOrderPopUp, sendAnalytics })(withTranslation('translations')(SpaBooking3a));